import { IGridPositionIndex, IPlacedDevice, IPosition } from './grid.model';

export interface ISLDProduct {
  canBeStartingPoint: boolean,
  canConsumeCurrentFromCombBusBar: boolean,
  canFeedCombus: boolean;
  cantBeFeederIfItIsUnderBusbar: boolean;
  isConsumer: boolean;
  isFeeder: boolean;
  isSpecialDevice: boolean;
  isOnlyFeeder: boolean;
  levels: Level[];
  connectionRules: ISLDConnectionRules;
  suitableForSLD: boolean;
}

export interface ISLDConnectionRules {
  childrenDevicesConnectionRules: ISLDConnectionRulesToDevice;
  connectionRulesToParent: ISLDConnectionRulesFrom;
  combBusBarRules: ISLDCombBusBarRules;
  unavailableLevels: Level[];
}

export interface ISLDCombBusBarRules {
  polesThatMakeConnection: number[];
  connectionToParent: ISLDConnectionRulesToDevice;
}

export interface ISLDConnectionRulesFrom {
  underCombBusBarAvailableConnectionFrom: ISldAvailableConnectionSide;
  standsAloneAvailableConnectionFrom: ISldAvailableConnectionSide;
}

export interface ISLDConnectionRulesToDevice {
  connectionsToLevels: ISLDAvailableConnectionSideTo[];
  exceptions: ISLDConnectionException[];
}

export interface ISLDAvailableConnectionSideTo {
  toLevel: Level;
  availableSides: ISldAvailableConnectionSide;
}

export interface ISLDConnectionException {
  rangeId: number;
  poleId: number;
  availableSides: ISldAvailableConnectionSide;
}

export enum Level {
  INCOMER_FEEDERS = 1,
  GROUP_FEEDERS = 2,
  FEEDERS = 3,
  CONSUMER = 4,
  SPECIAL_DEVICE = 5
}

export interface ISLDConnection {
  connections: ISLDConnectionItem[];
  level: Level;
  startOfFeedingTree: boolean;
  underWhatCombBusBarId: number;
  partOfSLD: boolean;
  dateCreated: string;
}

export interface ISLDConnectionItem {
  deviceId: number;
  sldConnection: ISLDConnection;
}

export enum SLDConnectionType {
  TOP = 1,
  BOTTOM = 2
}

export interface ISldTwoDevicesDevicesConnection {
  fromDevice: IPlacedDevice;
  toDevice: IDeviceConnecting;
}

export interface IDeviceConnecting {
  device: IPlacedDevice,
  connectedFrom: SLDConnectionType
}

export interface ISLDConnectionDTO {
  parentId: number;
  childId: number;
  connectionType: SLDConnectionType;
  connectionTypeFrom: SLDConnectionType;
}

export interface IFeedingTreeDevice {
  name: string;
  label: string;
  deviceId: number;
  ampere: string;
  deviceUuid: string;
  levelBelowConnectionHolder: boolean;
  sldConnection: ISLDConnection;
  children: IFeedingTreeDevice[];
  deselectionAvailable: boolean;
  position: IPosition;
  enclosureField: IGridPositionIndex;
}

export interface IFeedingTreeDevicesUnderBusbar {
  combBusbarId: number;
  devices: IFeedingTreeDevice[];
  isSelectable: boolean;
}

export enum SldMode {
  NONE,
  DEFAULT,
  LOADING,
  OVERLAY_LOADING,
  CHOOSING_STARTING_POINT,
  ADDING_DEVICE_TO_SLD,
  PRESS_TO_START_A_TREE
}

export interface ISldAvailableConnectionSide {
  top: boolean;
  bottom: boolean;
}

export interface IAvailableSidesCombinations {
  bothAvailable: ISldAvailableConnectionSide;
  topAvailable: ISldAvailableConnectionSide;
  bottomAvailable: ISldAvailableConnectionSide;
  noneAvailable: ISldAvailableConnectionSide;
}

export interface IConfirmationConnection {
  option: SLDConnectionType,
  devices: ISldTwoDevicesDevicesConnection
}

export interface IPowerTagOnSld {
  attachedToDeviceId: string;
  label: string;
}
